import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';


export default function CoralLayout({ p }) {
  const T = p.storeTheme || {};
  
  const copy = getHeroContent(p, {
    eyebrow: "Summer Vibes",
    title: "Bold. Bright. Beautiful.",
    subtitle: "Stand out with our curated collection",
    primaryCta: "Shop Collection",
    secondaryCta: "Learn More",
  });

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-rose-50 via-orange-50 to-pink-50" style={{ fontFamily: T.fontFamily || "DM Sans, sans-serif" }}>
      {/* Colorful Top Bar */}
      <div className="bg-gradient-to-r from-rose-500 via-orange-500 to-pink-500 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm">
          ✨ Free shipping on orders over ₹999 | Limited time offer ✨
        </div>
      </div>

      {/* Navigation */}
      <nav className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-rose-100">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-4">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-rose-300" />
          <div className="flex-1">
            <p className="font-bold text-gray-800">{p.storeInfo?.businessName}</p>
            <div className="flex gap-2 text-xs">
              <span className="text-rose-500">★ 4.9 (2.3k reviews)</span>
            </div>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 max-w-md" />
          <div className="flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-full bg-rose-50 text-rose-500 hover:bg-rose-100 transition">
              <FaHeart />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-rose-500 text-white text-[10px] flex items-center justify-center">{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>

      {/* Hero Card */}
      <section className="max-w-7xl mx-auto w-full px-4 pt-8">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-r from-rose-500 via-orange-500 to-pink-500 shadow-xl">
          <div className="grid md:grid-cols-2 gap-8 p-8 md:p-12">
            <div className="text-white">
              <span className="inline-block px-3 py-1 rounded-full bg-white/20 text-sm mb-4 backdrop-blur"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
              <h1 className="text-4xl md:text-5xl font-bold leading-tight"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
              <p className="mt-4 text-white/90 text-lg"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
              <div className="mt-8 flex gap-3">
                <button onClick={() => p.setActiveTab("products")} className="px-6 py-3 rounded-full bg-white text-rose-600 font-bold hover:shadow-lg transition"><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
                <button onClick={() => p.setActiveTab("details")} className="px-6 py-3 rounded-full border border-white/30 text-white font-semibold hover:bg-white/10 transition"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
              </div>
            </div>
            <div className="relative">
              <HeroImage p={p} themeId="coral" className="h-64 rounded-2xl shadow-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <div className="max-w-7xl mx-auto w-full px-4 mt-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: "🎁", label: "Free Gift Wrap", color: "rose" },
            { icon: "⚡", label: "Express Delivery", color: "orange" },
            { icon: "🔄", label: "Easy Exchange", color: "pink" },
            { icon: "🎯", label: "Buyer Protection", color: "rose" },
          ].map(f => (
            <div key={f.label} className={`bg-${f.color}-50 rounded-xl p-3 text-center border border-${f.color}-200`}>
              <div className="text-2xl mb-1">{f.icon}</div>
              <div className="text-sm font-semibold text-gray-700">{f.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto w-full px-4 mt-8">
        <div className="flex gap-2 border-b border-rose-200">
          {[["products", getTabLabel(p, "products")], ["services", getTabLabel(p, "services")], ["details", getTabLabel(p, "details")]].map(([k, l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className={`px-6 py-3 text-sm font-semibold transition relative ${p.activeTab === k ? "text-rose-600" : "text-gray-500"}`}>
              {l}
              {p.activeTab === k && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-rose-500 to-orange-500 rounded-full" />}
            </button>
          ))}
        </div>
      </div>

      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-8">
        <TabContent p={p} />
      </section>

      <StoreFooter p={p} />
    </div>
  );
}